import React from 'react'
import { Link } from 'react-router-dom'

export default function CleanEnergyTechnolgiesGridCard({ link, image, title }) {
  return (
    <Link
      to={link}
      className={`col-span-12 md:col-span-6 lg:col-span-4`}
    >
      <div className={`hover:border-secondary-600 border-muted-300 flex h-[320px] transform cursor-pointer flex-col items-center justify-center border-2 p-4 duration-500 ease-in-out hover:bg-light`}>
        <img
          className={`h-[128px]`}
          src={image}
          alt={title}
        />
        <h2 className={`mt-4 text-center text-lg font-bold`}>{title}</h2>
      </div>
    </Link>
  )
}
